import { money } from "../../utilities/currency";

/**
 * Norwegian — source language. Other locales fall back to these keys.
 * Each top-level key is a "namespace" matching the `T` object a page/component uses.
 */
const no = {
  home: {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Få din første konsultasjon gratis!",
    referBody:
      "Book en 15-minutters gratis samtale. Perfekt for å finne riktig rådgiver – trygt, digitalt og uten forpliktelser.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Book gratis konsultasjon",
    sponsored: "Sponset",
    ad: (n) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
      "Kjærlighetsreading",
      "Klarsynt reading",
      "Tarot‑reading",
      "Astrologi & Horoskop",
      "Englebudskap",
      "Orakel‑veiledning",
      "Drømmetydning",
      "Åndelig medium",
    ],
    hero: {
      name: "Rådgiverne",
      tag: "Kjærlighetsekspert",
      blurb:
        "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
      getReading: "Bestill konsultasjon",
    },
    footer: {
      getApp: "Få appen for klarhet hvor du enn er.",
      explore: "Utforsk",
      special: "Spesialiteter",
      more: "Mer",
      advisors: "Veiledere",
      blog: "Bloggen vår",
      applyCode: "Bruk kampanjekode",
      support: "Kundesupport",
      about: "Om oss",
      apply: "Veileder? Søk her",
      privacy: "Personvern",
      terms: "Vilkår",
    },
    wallet: {
      title: "Kjøp ringeminutter",
      intro:
        "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
      numLabel: "Telefonnummeret du ringer fra",
      amount: "Velg beløp",
      buy: (amt) => `Kjøp ${money(amt)} kreditt`,
      learn: "Les mer om betalingsmåter",
      err: "Skriv inn et gyldig telefonnummer",
      otp: (n) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
      enterOtp: "Skriv inn kode",
      verify: "Bekreft & legg til kreditt",
      cancel: "Avbryt",
      success: (amt) => `${money(amt)} lagt til i lommeboken!`,
      pm1: "Vipps MobilePay",
      pm2: "Kort (krever registrering på ditt mobilnummer)",
      nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
  },

  header: {
    hello: "Hei",
    logout: "Logg ut",
    login: "Logg inn",
  },

  footer: {
    categories: [
      "Dummy 1",
      "Dummy 2",
      "Dummy 3",
      "Dummy 4",
      "Dummy 5",
      "Dummy 6",
      "Dummy 7",
      "Dummy 8",
    ],
    paymentMethods: "Betalings metoder",
    footer: {
      getApp: "Få appen for klarhet hvor du enn er.",
      explore: "Utforsk",
      special: "Spesialiteter",
      more: "Mer",
      advisors: "Veiledere",
      blog: "Bloggen vår",
      applyCode: "Bruk kampanjekode",
      support: "Kundesupport",
      about: "Om oss",
      apply: "Veileder? Søk her",
      privacy: "Personvern",
      terms: "Vilkår",
    },
  },
};

export default no;
